import React from "react";
import { X, MapPin } from "lucide-react";

interface MapModalProps {
  fotoMapa: string;
  cidade: string;
  nomeLocal: string;
  onClose: () => void;
}

export default function MapModal({ fotoMapa, cidade, nomeLocal, onClose }: MapModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-6xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "#F8EBC1", maxHeight: "95vh" }}
      >
        {/* Header */}
        <div className="flex items-start justify-between p-6 border-b" style={{ borderColor: "#3A282433" }}>
          <div className="flex items-start gap-3">
            <MapPin className="w-5 h-5 mt-0.5" style={{ color: "#DA422F" }} />
            <div>
              <p className="text-xs tracking-[0.2em] uppercase mb-1" style={{ color: "#3A282866" }}>
                Mapa do Evento
              </p>
              <h3 className="text-xl font-bold uppercase tracking-tight" style={{ color: "#3A2824", fontFamily: "var(--font-oswald)" }}>
                {cidade}
              </h3>
              <p className="text-sm uppercase tracking-wider mt-0.5" style={{ color: "#3A282866" }}>
                {nomeLocal}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="transition hover:opacity-60"
            style={{ color: "#3A282866" }}
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Map Image */}
        <div className="p-6 overflow-auto" style={{ maxHeight: "calc(95vh - 120px)" }}>
          <div className="relative w-full overflow-hidden rounded-lg shadow-lg">
            <img
              src={fotoMapa}
              alt={`Mapa do evento - ${cidade}`}
              className="w-full h-auto object-contain"
              style={{ backgroundColor: "#fff" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
